// extracted by mini-css-extract-plugin
export default {"socialProofTitle":"_HcGi5","mobile":"LGGx6v"};